export default "__VITE_ASSET__CgAlKSkj__"